var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5",staticStyle:{"height":"300px"}},[(_vm.dialogLoading)?_c('div',{staticClass:"loading-state"},[_c('div',{staticClass:"loading"}),_c('span',{staticClass:"ml-3 loading-text"},[_vm._v(_vm._s(_vm.$t('contrat.payment_success.title')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }